<template>
  <button @click="toggleTheme" class="theme-button" aria-label="Toggle Theme">
    <img
      src="@/assets/themeSwitch.svg"
      alt="Theme Icon"
      class="theme-icon"
    />
  </button>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const userTheme = ref("light-theme")

const toggleTheme = () => {
  const newTheme = userTheme.value === "light-theme" ? "dark-theme" : "light-theme"
  setTheme(newTheme);
}

const getTheme = () => {
  return localStorage.getItem("user-theme")
}

const setTheme = (theme) => {
  localStorage.setItem("user-theme", theme)
  userTheme.value = theme
  document.documentElement.className = theme
  window.dispatchEvent(new Event('theme-changed'))
}

const getMediaPreference = () => {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark-theme" : "light-theme"
}

onMounted(() => {
  const initUserTheme = getTheme() || getMediaPreference()
  setTheme(initUserTheme)
})
</script>

<style scoped>
  .theme-button {
    position: fixed;
    top: 1rem;
    right: 1rem;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 999;
    padding: 0;
  }

  .theme-icon {
    width: 25px;
    height: 25px;
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
</style>